"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var store_component_1 = __importDefault(require("@hikakaku/shared/components/estimate_form/common/store_component"));
var input_wrapper_1 = __importDefault(require("@hikakaku/shared/components/estimate_form/common/input/input_wrapper"));
var brand_block_1 = __importDefault(require("@hikakaku/shared/components/estimate_form/common/brand_block"));
var ItemInputCard = (0, mobx_react_1.observer)(function (_a) {
    var store = _a.store;
    return (react_1.default.createElement("div", { ref: store.cardRef, className: "estimateForm-InputCard" },
        react_1.default.createElement("div", { className: "estimateForm-InputCard_Header" },
            "\u67FB\u5B9A\u5E0C\u671B\u5546\u54C1 ",
            store.index + 1,
            react_1.default.createElement("button", { onClick: store.handleClickDeleteButton, className: "estimateForm-InputCard_DeleteButton" },
                react_1.default.createElement("i", { className: "fa fa-times" }))),
        store.topElementStore && react_1.default.createElement(store_component_1.default, { store: store.topElementStore }),
        react_1.default.createElement("div", null,
            store.categorySelectorInputStore &&
                react_1.default.createElement(input_wrapper_1.default, { store: store.categorySelectorInputStore },
                    react_1.default.createElement(store_component_1.default, { store: store.categorySelectorInputStore })),
            react_1.default.createElement(brand_block_1.default, { isVisible: store.showBrandBlock, categoryId: store.selectedCategoryId, categoryName: store.selectedCategoryName, cardNumber: store.cardNumber, onValueChange: function (value, categoryId, modelNameLabel) {
                    store.brandBlockValue = value;
                    store.selectedModelNameLabel = modelNameLabel;
                }, onBrandBlockClick: function (selectedBrandCategoryId) { return store.handleBrandBlockClick(selectedBrandCategoryId); }, onBrandBlockClear: store.handleBrandBlockClear }),
            react_1.default.createElement(store_component_1.default, { store: store.inputListStore }))));
});
exports.default = ItemInputCard;
